import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.MoreDetails = {
  displayName: 'MoreDetails',

  onLeftNavButtonClick(onStepProgression) {
    if (Job.Data.showSuppressants) {
      JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.ContactPreference)
    }
  },

  buttonLayout: function() {
    return 'none'
  },

  component: React.createClass({
    getInitialState: function() {
      return {
        loading: false
      }
    },

    componentDidMount: function() {
      this.toggleModalFooter('hide')

      Job.Actions.updateChoseMoreDetails(false)
      if (Job.Data.categoryId && Job.Data.category) {
        let subcategory = { id: Job.Data.categoryId, value: Job.Data.category }
        this.selectSubcategory(subcategory)
      }
    },

    moreDetailsChosen: function() {
      Job.Actions.updateChoseMoreDetails(true)
      this.toggleModalFooter('show')

      if (Job.Questions[Job.Data.categoryId]) {
        JobWizard.Emitter.emit('job:wizard:advanceToNextStep')
      } else {
        JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.Budget)
      }
    },

    skipDetailsChosen: function() {
      SS.appFn.appMsg({ id: Job.Data.id, status: 'rush' }) // used by mobile app for controlling the flow
      JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.UpdateJob)
    },

    toggleModalFooter: function(action) {
      let footer = $('#job-modal').find('.modal-footer')
      action === 'show' ? footer.show() : footer.hide()
    },

    showModalCloseButton: function() {
      $('#job-modal')
        .find('.modal-header')
        .find('.close')
        .rmHidden()
    },

    selectSubcategory: function(subcategory) {
      Job.Actions.updateCategory(subcategory)
      Job.Actions.updateSubCategory(subcategory, 'add')
      JobWizard.Emitter.emit('job:wizard:categorySelected', null, { item: subcategory })
    },

    redirectToJobPage: function(){
      document.location.href = this.redirectUrl()
    },

    redirectUrl: function() {
      switch (Job.Data.referrer.cta) {
        case 'profile': {
          return `/jobs/${this.job.id}/profilejob?successful_job=true`
        }
        case 'business_directory_card': {
          return `/jobs/${this.job.id}/bcardjob?successful_job=true`
        }
        default: {
          return `/jobs/${this.job.id}/posted?successful_job=true`
        }
      }
    },

    render: function() {
      return (
        <div>
          <div className="form-group pb30">
            <h3 className="mb15 mt10">What would you like to do?</h3>
            <div className={`${this.state.loading ? '' : 'hidden'}`}>
              <div className="modal-body job-form-body radius-16-bottom">
                <div className="spinner-icon text-center"/>
              </div>
            </div>
            <div className={`${this.state.loading ? 'hidden' : ''} radio-button-box minor-bold`} id="more-details-radio-group">
              <div className="radio more-details" onClick={this.moreDetailsChosen}>
                <div className="row" role="tab" data-toggle="tab">
                  <div className="col-xs-10 col-sm-10">Answer a few more questions now (so businesses have more info when
                        they are invited to quote)</div>
                  <input type="radio" name="more_details" value="true" className="form-control invisible"/>
                </div>
              </div>
              <div className="radio no-details" role="tab" data-toggle="tab" onClick={this.skipDetailsChosen}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10">Invite businesses to quote now</div>
                  <input type="radio" name="more_details" value="false" className="form-control invisible"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  })
}
